"use client";

import * as React from "react";
import { Check, Info } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function SchoolPricing() {
  return <section id="schoolpricing" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 overflow-hidden">
      <div id="pricing-nha-truong" className="sr-only" aria-hidden="true" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* Section Heading */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground uppercase">
            BÁO GIÁ DÀNH CHO NHÀ TRƯỜNG
          </h2>
        </div>

        {/* Tabbed Pricing Selector */}
        <Tabs defaultValue="international" className="w-full">
          <div className="flex justify-center mb-10 md:mb-12">
            <TabsList className="h-auto p-1.5 bg-muted/70 border border-border rounded-xl flex-wrap justify-center gap-1 shadow-xs">
              <TabsTrigger value="international" className="px-4 py-2.5 rounded-lg text-xs sm:text-sm font-semibold transition-all data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-sm">
                QUỐC TẾ / SONG NGỮ / DÂN LẬP
              </TabsTrigger>
              <TabsTrigger value="public" className="px-4 py-2.5 rounded-lg text-xs sm:text-sm font-semibold transition-all data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-sm">
                CÔNG LẬP
              </TabsTrigger>
              <TabsTrigger value="partner" className="px-4 py-2.5 rounded-lg text-xs sm:text-sm font-semibold transition-all data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-sm">
                ĐỐI TÁC LIÊN KẾT
              </TabsTrigger>
            </TabsList>
          </div>

          {/* Group A: QUỐC TẾ / SONG NGỮ / DÂN LẬP */}
          <TabsContent value="international" className="focus-visible:outline-none">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
              {/* Card A1: DẠY CHÍNH KHÓA */}
              <Card className="bg-card border border-border shadow-md rounded-xl flex flex-col justify-between hover:shadow-lg transition-shadow">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl font-bold text-foreground">
                    DẠY CHÍNH KHÓA
                  </CardTitle>
                  <p className="text-xs text-muted-foreground mt-2 font-medium leading-relaxed">
                    Robotics, Mindcraft, In 3D, Lập trình, AI, …
                  </p>
                </CardHeader>
                <CardContent className="pt-0 flex flex-col gap-6 flex-1 justify-between">
                  <div className="py-2">
                    <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                      500.000 – 600.000
                    </div>
                    <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-1">
                      VNĐ / tiết
                    </div>
                  </div>

                  <div className="space-y-3 pt-4 border-t border-border text-sm">
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Tần suất:</span>
                      <span className="font-semibold">1 – 2 tiết / tuần</span>
                    </div>
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Chi phí ban đầu:</span>
                      <span className="font-semibold text-primary">0 VNĐ</span>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Card A2: DẠY CÂU LẠC BỘ — NGOÀI GIỜ */}
              <Card className="bg-card border border-border shadow-md rounded-xl flex flex-col justify-between hover:shadow-lg transition-shadow">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl font-bold text-foreground">
                    DẠY CÂU LẠC BỘ — NGOÀI GIỜ
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex flex-col gap-6 flex-1 justify-between">
                  <div className="py-2">
                    <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                      100.000 – 120.000
                    </div>
                    <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-1">
                      VNĐ / học sinh / buổi
                    </div>
                  </div>

                  <div className="space-y-3 pt-4 border-t border-border text-sm">
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Thời lượng:</span>
                      <span className="font-semibold">60 – 90 phút / buổi</span>
                    </div>
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Chi phí ban đầu:</span>
                      <span className="font-semibold text-primary">0 VNĐ</span>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Card A3: CHUYỂN GIAO CHƯƠNG TRÌNH */}
              <Card className="bg-card border border-border shadow-md rounded-xl flex flex-col justify-between hover:shadow-lg transition-shadow">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl font-bold text-foreground">
                    CHUYỂN GIAO CHƯƠNG TRÌNH
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex flex-col gap-5 flex-1 justify-between">
                  <div className="space-y-3 py-2">
                    <div>
                      <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                        20.000.000
                      </div>
                      <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mt-1">
                        VNĐ / khối / 35 tiết / chương trình
                      </div>
                    </div>
                    <div className="text-sm font-semibold text-foreground/90 pt-1">
                      5.000.000 VNĐ / khối / năm
                    </div>
                  </div>

                  <div className="space-y-4 pt-3 border-t border-border">
                    <ul className="space-y-2 text-xs text-muted-foreground">
                      <li className="flex items-center gap-2">
                        <Check className="size-4 text-primary shrink-0" />
                        <span>Tập huấn</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <Check className="size-4 text-primary shrink-0" />
                        <span>Update chương trình</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <Check className="size-4 text-primary shrink-0" />
                        <span>Cuộc thi</span>
                      </li>
                    </ul>

                    <div className="p-3 bg-muted/50 rounded-lg text-xs text-muted-foreground italic flex items-start gap-2">
                      <Info className="size-4 text-muted-foreground shrink-0 mt-0.5" />
                      <span>
                        Nhà trường có thể lựa chọn một trong các sản phẩm/chương trình sẵn có của ROBOTO.
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Group B: CÔNG LẬP */}
          <TabsContent value="public" className="focus-visible:outline-none">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto items-stretch">
              {/* Card B1: ROBOTICS */}
              <Card className="bg-card border border-border shadow-md rounded-xl flex flex-col justify-between hover:shadow-lg transition-shadow">
                <CardHeader className="pb-4">
                  <CardTitle className="text-2xl font-bold text-foreground">
                    ROBOTICS
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex flex-col gap-6 flex-1 justify-between">
                  <div className="py-2">
                    <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                      100.000 – 120.000
                    </div>
                    <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-1">
                      VNĐ / tháng
                    </div>
                  </div>

                  <div className="pt-4 border-t border-border text-sm">
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Tần suất:</span>
                      <span className="font-semibold">1 tiết / tuần</span>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Card B2: STEM / AI */}
              <Card className="bg-card border border-border shadow-md rounded-xl flex flex-col justify-between hover:shadow-lg transition-shadow">
                <CardHeader className="pb-4">
                  <CardTitle className="text-2xl font-bold text-foreground">
                    STEM / AI
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex flex-col gap-6 flex-1 justify-between">
                  <div className="py-2">
                    <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                      80.000 – 100.000
                    </div>
                    <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide mt-1">
                      VNĐ / tháng
                    </div>
                  </div>

                  <div className="pt-4 border-t border-border text-sm">
                    <div className="flex justify-between items-center text-foreground">
                      <span className="text-muted-foreground">Tần suất:</span>
                      <span className="font-semibold">1 tiết / tuần</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Group C: ĐỐI TÁC LIÊN KẾT */}
          <TabsContent value="partner" className="focus-visible:outline-none">
            <div className="max-w-2xl mx-auto">
              <Card className="bg-card border border-border shadow-md rounded-xl hover:shadow-lg transition-shadow">
                <CardHeader className="text-center pb-4">
                  <span className="text-xs font-semibold text-primary uppercase tracking-wider mb-1">
                    MÔ HÌNH HỢP TÁC DOANH THU
                  </span>
                  <CardTitle className="text-2xl sm:text-3xl font-bold text-foreground">
                    HỆ SINH THÁI STEM
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-6 pt-2">
                  <div className="text-center py-4 bg-muted/40 rounded-xl border border-border/70">
                    <div className="text-3xl sm:text-4xl font-extrabold text-foreground tracking-tight">
                      50.000.000 – 100.000.000
                    </div>
                    <div className="text-xs sm:text-sm font-medium text-muted-foreground mt-1">
                      (Tùy khu vực)
                    </div>
                  </div>

                  <Separator />

                  <div>
                    <h3 className="text-sm font-bold text-foreground uppercase tracking-wider mb-4">
                      PHÍ HỢP TÁC:
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 p-3 rounded-lg bg-background border border-border">
                        <Check className="size-5 text-accent shrink-0" />
                        <span className="text-sm font-medium text-foreground">
                          3% doanh thu trong năm đầu
                        </span>
                      </div>
                      <div className="flex items-center gap-3 p-3 rounded-lg bg-background border border-border">
                        <Check className="size-5 text-accent shrink-0" />
                        <span className="text-sm font-medium text-foreground">
                          5% doanh thu từ năm thứ 2 trở đi
                        </span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>;
}